import React from 'react';
import {Route, Switch, withRouter, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import {
    ABOVE_THE_HEADER,
    BELOW_THE_HEADER,
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
import {isIOS, isMobile} from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';

const isLoggedIn = () => {
    return localStorage.getItem('accessToken') ? true : false;
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    isLoggedIn() === true
      ? <Component {...props} />
      : <Redirect to='/#/login' />
  )} />
)

class App extends React.Component {

    render() {
        const {match, drawerType, navigationStyle, horizontalNavPosition} = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

        //set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            document.body.classList.add('ios-mobile-view-height')
        }
        else if (document.body.classList.contains('ios-mobile-view-height')) {
            document.body.classList.remove('ios-mobile-view-height')
        }

        return (
            <div className={`app-container ${drawerStyle}`}>
                <Sidebar/>
                <div className="app-main-container">
                    <div
                        className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
                        {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
                        <TopNav styleName="app-top-header"/>}
                        <Header/>
                        {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
                        <TopNav/>}
                    </div>

                    <main className="app-main-content-wrapper">
                        <div className="app-main-content">
                            <Switch>
                                <PrivateRoute path={`${match.url}/report`} component={asyncComponent(() => import('./routes/Report'))}/>
                                {/*<PrivateRoute path={`${match.url}/results`} component={asyncComponent(() => import('./routes/Results'))}/> */}
                                {/*<PrivateRoute path={`${match.url}/deliveries`} component={asyncComponent(() => import('./routes/Deliveries'))}/> */}
                                <PrivateRoute path={`${match.url}/account`} component={asyncComponent(() => import('./routes/Account'))}/> 
                                <PrivateRoute path={`${match.url}/subscription`} component={asyncComponent(() => import('./routes/Subscription'))}/> 
                                {/*<PrivateRoute path={`${match.url}/billing`} component={asyncComponent(() => import('./routes/BillingInformation'))}/> */}
                                {/* <PrivateRoute path={`${match.url}/contact`} component={asyncComponent(() => import('./routes/Contact'))}/>                                  */}
                                <Route component={asyncComponent(() => import('components/Error404'))}/>
                            </Switch>
                        </div>
                        <Footer/>
                    </main>
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({settings}) => {
    const {drawerType, navigationStyle, horizontalNavPosition} = settings;
    return {drawerType, navigationStyle, horizontalNavPosition}
};
export default withRouter(connect(mapStateToProps)(App));


// WEBPACK FOOTER //
// ./app/index.js